import React from 'react';
import { SVGProps } from './type';

export const IconDeveloperOption = ({ fill }: SVGProps) => {
  return (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.95 21.945h13.996a3 3 0 0 0 3 -3V4.95a3 3 0 0 0 -3 -3h-13.995a3 3 0 0 0 -3 3v13.995a3 3 0 0 0 3 3m14.997 -3a0.999 0.999 0 0 1 -1.001 1.001h-13.995a1.001 1.001 0 0 1 -1.001 -1.001V4.95c0 -0.553 0.447 -1.001 0.999 -1.001h13.996c0.552 0 1.001 0.447 1.001 0.999zM9.156 10.654a1.001 1.001 0 0 0 -1.413 -1.413L5.744 11.241a1.001 1.001 0 0 0 0 1.413L7.743 14.655a0.999 0.999 0 1 0 1.413 -1.413l-1.292 -1.293zm5.585 -1.413a1.001 1.001 0 0 0 0 1.413l1.293 1.293 -1.293 1.293a1.001 1.001 0 0 0 1.414 1.413l1.999 -1.999a0.999 0.999 0 0 0 0 -1.413L16.155 9.24a0.999 0.999 0 0 0 -1.414 0m-1.305 -0.129a0.999 0.999 0 1 0 -1.972 -0.33l-1.001 6a0.999 0.999 0 0 0 1.972 0.329z"
      fill={fill}
    />
  );
};
